export const UPSERT_ESSENTIAL_SCORES = 'essentialScores/UPSERT_ESSENTIAL_SCORES';
export const UPDATE_ESSENTIAL_SCORE = 'essentialScores/UPDATE_ESSENTIAL_SCORE';
export const UPDATE_ESSENTIAL_SCORES_CLOCKS = 'essentialScores/UPDATE_ESSENTIAL_SCORES_CLOCKS';
export const REMOVE_ESSENTIAL_SCORES = 'essentialScores/REMOVE_ESSENTIAL_SCORES';
export const ADD_COMMENT = 'essentialScores/ADD_COMMENT';
export const ADD_OVERVIEW_COMMENT = 'essentialScores/ADD_OVERVIEW_COMMENT';
export const UPDATE_MOST_RECENT_COMMENT_DISPLAY = 'essentialScores/UPDATE_MOST_RECENT_COMMENT_DISPLAY';
